require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-first-credit-union-selects-ning-duong-as-new-ceo.json") })
        }
      }, "path---articles-financial-center-first-credit-union-selects-ning-duong-as-new-ceo");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-first-credit-union-selects-ning-duong-as-new-ceo!./.cache/json/articles-financial-center-first-credit-union-selects-ning-duong-as-new-ceo.json
// module id = 1618
// module chunks = 231608221292675